var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left pb-50",class:_vm.isNavLinkActive(_vm.menuItem) ? 'active' : ''},[_c('router-link',{attrs:{"to":_vm.menuItem.route ? _vm.menuItem.route : ''}},[_vm._v(" "+_vm._s(_vm.$t(_vm.menuItem.title))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }